import { client } from '@global/Api';
import { RootState, store } from '@global/store/store';
import { UPDATE_BILLING_INFORMATION } from '@global/requests/checkout';
import { buildVariablesForUpdateBillingInfo } from '@pages/checkout/components/BillingInformation/helper';
import { BillingInfoFormValuesType } from '@global/components/BillingInfoForm/types';
import { constructBillingInfo } from '@pages/checkout/components/BillingInformation/helper';

export async function saveCartBillingAddress(
  formValues: BillingInfoFormValuesType
): Promise<void> {
  try {
    const { cart, country } = store.getState() as RootState;

    const billingAddress = constructBillingInfo(
      cart.billingInfo,
      formValues,
      country.countries
    );
    const variables = buildVariablesForUpdateBillingInfo(
      billingAddress,
      cart.cartId,
      cart.agreementCheck
    );

    await client.mutate({
      mutation: UPDATE_BILLING_INFORMATION,
      variables: variables,
    });
  } catch (error) {
    console.error(error);
  }
}
